// extracted by mini-css-extract-plugin
module.exports = {"VisualData":"VisualData_VisualData__2c5vr","graphWrapper":"VisualData_graphWrapper__2A2x4","sidebarWrapper":"VisualData_sidebarWrapper__2XjfI","panel":"VisualData_panel__263ad"};